import { useContext, useEffect } from 'react';
import { useLoaderData, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';

const RecruiterBroadCast = () => {
    const { pageName } = useParams();
    const { globalState } = useContext(GlobalContext);

    const [searchParams] = useSearchParams();
    const universityId = searchParams.get('universityId');
    const navigate = useNavigate();
    const { state } = useLocation();
    const selectedIds = state?.student_data_for_email;

    console.log("selectedIds",selectedIds)
};

export default RecruiterBroadCast;
